import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { PATHS } from "@/lib/router";

const NotFoundPage = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary">404</h1>
        <h2 className="mt-4 text-3xl font-semibold text-foreground">
          Page not found
        </h2>
        <p className="mt-2 text-muted-foreground">
          Sorry, we couldn't find the page you're looking for.
        </p>
        <Link
          to={PATHS.ROOT}
          className="mt-8 inline-flex items-center gap-2 rounded-radius bg-primary px-4 py-2 font-semibold text-primary-foreground hover:bg-primary/90"
        >
          <Home className="h-4 w-4" />
          Go back home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
